export default {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	data() {
		return {
			statuses: [
				{name: "Active", value: false},
				{name: "Inactive", value: true},
				{name: "Unlock", value: "Unlock"},
				{name: "Lock", value: "Lock"}
			]
		}
	},
	methods: {
		getActiveStatuses(statuses: any) {
			return statuses.filter((s: any) => s.name == "Active" || s.name == "Inactive");
		}, 
		getUserStatuses(statuses: any) {
			return statuses;
		}
	}
};